module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-53.b543348d.svg";